import { IntervalType, IntervalValue } from '@client/api';

import { i18n } from '../../i18n';

type Interval = IntervalValue | null | undefined;

export const hasIntervalCount = (count: unknown): count is NonNullable<number> => {
  if (count == null) return false;
  if (typeof count !== 'number') return false;
  if (isNaN(count)) return false;
  return true;
};

export const hasIntervalType = (type: unknown): type is NonNullable<IntervalType> => {
  if (type == null) return false;
  if (typeof type !== 'string') return false;
  if (type.trim() === '') return false;
  return true;
};

export const toIntervalString = (interval: Interval, placeholder: string | undefined = undefined) => {
  if (interval == null) return placeholder;
  if (!hasIntervalCount(interval.count)) return placeholder;
  if (!hasIntervalType(interval.type)) return placeholder;

  if (interval.type === 'Year' && interval.count === 1) {
    return i18n.t('IntervalOption.Yearly', { ns: 'type' });
  }

  if (interval.type === 'Month') {
    switch (interval.count) {
      case 1:
        return i18n.t('IntervalOption.Monthly', { ns: 'type' });
      case 2:
        return i18n.t('IntervalOption.EveryTwoMonth', { ns: 'type' });
      case 3:
        return i18n.t('IntervalOption.EveryThreeMonth', { ns: 'type' });
      case 4:
        return i18n.t('IntervalOption.EveryFourMonth', { ns: 'type' });
      case 5:
        return i18n.t('IntervalOption.EveryFiveMonth', { ns: 'type' });
      case 6:
        return i18n.t('IntervalOption.EverySixMonth', { ns: 'type' });
    }
  }

  return i18n.t('price.intervalDescription', {
    count: interval.count,
    type: interval.type,
    ns: 'global',
    defaultValue: undefined,
  });
};

export const isValidDefinedInterval = (interval: Interval): boolean =>
  interval != null && hasIntervalCount(interval.count) && hasIntervalType(interval.type);
